import {
    pipe,
    pathOr,
    path,
    lt
} from 'ramda'

export const isUpcoming = pipe(
    path(['meta', 'eventStartDate']),
    Date.parse,
    lt(Date.now())
)

export const isFeatured = pipe(
    pathOr(false, ['meta', 'eventFeatured']),
)